var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"layout",staticClass:"layout--empty"},[_c('main',{ref:"main",staticClass:"empty"},[_c('div',{staticClass:"empty__container"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }